module.exports = __webpack_public_path__ + "static/img/tap-left-0.695dc58.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/tap-left-0.png
// module id = eXIx
// module chunks = 1